import { Expose, Type } from 'class-transformer'
import { LevelType } from './LevelType'

export class UserMissionLevelFormType {
  @Expose()
  @Type(() => LevelType)
  userMissionLevels: LevelType[]
}
